import enlocale from 'element-ui/lib/locale/lang/en'

const en = {
  'index': {
    'Projects': 'Projects',
    'Open': 'Open',
    'Closed': 'Closed',
    'NewProject': 'New Project',
    'SearchProjectNameOrAddress': 'Search project name or address',
    'Filters': 'Filters',
    'Updated': 'Updated {date}',
    'NoData': 'No Data',
    'Name': 'Name',
    'User': 'User',
    'CreatedFrom': 'Created from',
    'CreatedTo': 'Created to',
    'daysAgo': ' days ago',
    'hoursAgo': ' hours ago',
    'minutesAgo': ' minutes ago',
    'CreateBy': 'Created by',
    'Members': 'Members',
    'Tutorials': 'Tutorials',
    'DownloadApp': 'Download App'
  },
  '404': {
    'OOPS': 'OOPS',
    'ThePageYouWereLookingForIsMissing': 'The page you were looking for is missing',
    'check': 'Please check that the URL you entered is correct, click the button below to return',
    'Back': 'Back'
  },
  'corp': {
    'ExpiredOn': 'Expired On',
    'SwitchCorp': 'Switch Corp',
    'EditProfile': 'Edit Profile',
    'Paid in Apple': 'Paid in Apple',
    'total': 'Total',
    'User': 'User',
    'PaymentMethod': 'Payment Method',
    'Type': 'Type',
    'Chinese': 'Chinese',
    'English': 'English',
    'BatchDelete': 'Batch Delete',
    'Welcome': 'Welcome, {user}',
    'EditCorp': 'Edit Corp',
    'CategoryName': 'Category Name',
    'Action': 'Action',
    'Edit': 'Edit',
    'Settings': 'Settings',
    'CompanyName': 'Company Name',
    'CorpSetting': 'Corp Setting',
    'M2Integration': 'M2 Integration',
    'Categories': 'Categories',
    'Unit': 'Unit',
    'TemperatureUnit': 'Temperature Unit',
    'Save': 'Save',
    'LaborItems': 'Labor Items',
    'NewLaborItem': 'New Labor Item',
    'Name': 'Name',
    'InstallCarpet': 'Install Carpet',
    'InstallVinyl': 'Install Vinyl',
    'InstallWallPaper': 'Install WallPaper',
    'InstallTile': 'Install Tile',
    'InstallLaminate': 'Install Laminate',
    'InstallHardwood': 'Install Hardwood',
    'Install Carpet': 'Install Carpet',
    'Install Vinyl': 'Install Vinyl',
    'Install WallPaper': 'Install WallPaper',
    'Install Tile': 'Install Tile',
    'Install Laminate': 'Install Laminate',
    'Install Hardwood': 'Install Hardwood',
    'Price': 'Price',
    'PleaseCheckOneLaborItemAtLast': 'Please check one labor item at last',
    'AreYouSureYouWantToDeleteTheseLaborItems': 'Are you sure you want to delete these labor items?',
    'TIPS': 'TIPS',
    'Yes': 'Yes',
    'No': 'No',
    'Licenses': 'Licenses',
    'Total': 'Total {0}, Remaining {1}',
    'remaining': 'remaining',
    'Storage': 'Storage',
    'Expired': 'Expired',
    'NextBilling': 'Next billing',
    'Upgrade': 'Upgrade',
    'Buy': 'Buy',
    'PaymentHistory': 'Payment History',
    'SubscriptionID': 'Subscription ID',
    'Item': 'Item',
    'Quantity': 'Quantity',
    'Rate': 'Rate',
    'Subscription': 'Subscription {type}, waiting for payment',
    'RenewedOn': 'Renewed on',
    'ProrationCharged': 'Proration charged on',
    'NextBillingDateIs': 'Next billing date is',
    'SubscriptionCreated': 'Subscription created, waiting for payment',
    'SubscriptionResumed': 'Subscription resumed, waiting for payment',
    'SubscriptionPauseResumed': 'Subscription resumed',
    'SubscriptionUpdated': 'Subscription updated',
    'SubscriptionCanceled': 'Subscription Canceled',
    'SubscriptionFailed': 'Paid failed',
    'SubscriptionPaused': 'Subscription paused',
    'SubscriptionTryPay': 'Invoice created, waiting for payment',
    'SubscriptionSent': 'Invoice sent, waiting for payment',
    'sSubscription': '\'s subscription',
    'Add': 'Add',
    'Remove': 'Remove',
    'TurnOnAuto-Bill': 'Turn On Auto-Bill',
    'TurnOffAuto-Bill': 'Turn Off Auto-Bill',
    'Cancel': 'Cancel',
    'Resume': 'Resume',
    'Pause': 'Pause',
    'LoadHistory': 'View History',
    'CreatedOn': 'Created On',
    'Amount': 'Amount',
    'Status': 'Status',
    'Invoice#': 'Invoice #',
    'Note': 'Note',
    'TrakrStarter(Trial)': 'Trakr Starter (Trial)',
    'EditPassword': 'Edit Password',
    'Activities': 'Activities',
    'NoData': 'No Data',
    'createdaTask': 'created a task ({TaskName})',
    'assignTheTask': 'assigned the task ({0}) to {1}',
    'setTheProgress': 'set the progress of task ({0}) to {1} %',
    'deletedaTask': 'deleted a task ({0})',
    'addRHReadingToTask': 'added RH reading to task({0})',
    'addCaClReadingToTask': 'added CaCl reading to task({0})',
    'removeaRH': 'removed a RH reading from task ({0})',
    'removeaCaCl': 'removed a CaCl reading from task ({0})',
    'NewUser': 'New User',
    'LoginAccount': 'Login Account',
    'ManageMySubscription': 'Manage Subscription',
    'Role': 'Role',
    'CreatedTime': 'Created Time',
    'License': 'License',
    'Delete': 'Delete',
    'AreYouSureYouWantToDeleteThisUser': 'Are you sure you want to delete this user?',
    'ConfigLanguage': 'Config Language',
    'LastActivity': 'Last Active',
    'TotalProjectCount': '# Projects',
    'TotalUserCount': '# Users',
    'TotalCompletedTaskCount': '# Tasks(Completed)',
    'TotalAssignToTaskCount': '# Assigned',
    'TotalAssignedTaskCount': '# Assigned Tasks',
    'More': 'More',
    'Mock': 'Mock',
    'Assign User To Corp': 'Assign User to Corp',
    'Created': 'Created',
    'IsActive': 'Is Active',
    'NoAvailableLicense': 'No available license for the user.',
    'PleaseUpgrade': 'Please upgrade to purchase more licenses.',
    'PleasePurchaseMore': 'Please purchase more licenses.',
    'SearchUserName': 'Search user name',
    'SearchLoginAccount': 'Search login account',
    'SendNotification': 'Send Notification',
    'NotificationEvents': 'Notification Events',
    'Project': 'Project',
    'Plan': 'Plan',
    'Task': 'Task',
    'Report': 'Report',
    'Create': 'Create',
    'Update': 'Update',
    'Close': 'Close',
    'CloseReopen': 'Close/Reopen',
    'Rename': 'Rename',
    'Assign': 'Assign',
    'ChangeProgress': 'Change Progress',
    'Complete': 'Complete',
    'AddMember': 'Add Member',
    'DeleteMember': 'Delete Member',
    'NewChecklistTemplate': 'New Checklist Template',
    'SearchTemplateName': 'Search template name',
    'AreYouSureYouWantToDeleteThisChecklistTemplate': 'Are you sure you want to delete this checklist template?',
    'GroupName': 'Group Name',
    'NewTaskTemplate': 'New Task Template',
    'AreYouSureYouWantToDeleteThisTaskTemplate': 'Are you sure you want to delete this task template?',
    'AddChecklist': 'Add Checklist',
    'AddChecklistItem': 'Add Checklist Item',
    'DeleteChecklistItem': 'Delete Checklist Item',
    'RenameChecklistItem': 'Rename Checklist Item',
    'CheckChecklistItem': 'Check Checklist Item',
    'CrossChecklistItem': 'Cross Checklist Item',
    'AddDocument': 'Add Document',
    'DeleteDocument': 'Delete Document',
    'AddPhoto': 'Add Photo',
    'DeletePhoto': 'Delete Photo',
    'AddVideo': 'Add Video',
    'DeleteVideo': 'Delete Video',
    'AnnotatePhoto': 'Annotate Photo',
    'FirstLoginTime': 'First Login',
    'NewTag': 'New Tag',
    'TagColor': 'Color',
    'AreYouSureYouWantToDeleteThisTag': 'Are you sure you want to delete this tag?',
    'AreYouSureYouWantToDeleteThisObjectTag': 'The tag is being used by the plans. Are you sure you want to delete it?',
    'TagNameIsNotEmpty': 'Name is Not Empty',
    'NewTaskGroupTemplate': 'New Task Group Template',
    'AreYouSureYouWantToDeleteThisTaskGroupTemplate': 'Are you sure you want to delete this task group template?',
    'SearchTagName': 'Search tag name'
  },
  'layout': {
    'Filter': 'Filter',
    'Clearfilter': 'Clear filter',
    'ManageMySubscription': 'Manage Subscription',
    'Upgrade': 'Upgrade to get unlimited projects & more.',
    'Buy': 'Buy',
    'SearchOrJumpTo': 'Search or jump to',
    'AllReport': 'All Report',
    'Management': 'Management',
    'MyCorp': 'My Corp',
    'MyProfile': 'My Profile',
    'LogOut': 'Log Out',
    'EndMock': 'End Mock',
    'MyTasks': 'My Tasks',
    'Reports': 'Reports'
  },
  'welcome': {
    'TIPS': 'TIPS',
    'Yes': 'Yes',
    'No': 'No',
    'LogInToYourAccount': 'Log in to your account',
    'NotRegistered': 'Not registered?',
    'SignUp': 'Sign Up',
    'MeasureSquareID': 'Measure Square ID (Email) *',
    'Password': 'Password *',
    'ForgotPassword': 'Forgot password?',
    'Login': 'Login',
    'MeasureSquareIDisRequired': 'Measure Square ID is required',
    'PasswordIsRequired': 'Password is required',
    'CreateYourAccount': 'Create your Account',
    'AlreadyHaveAnAccount': 'Already have an account?',
    'SignIn': 'Sign In',
    'Name': 'Name *',
    'BusinessName': 'Business Name *',
    'YouNeedToEnteraValidemail': 'You need to enter a valid email',
    'LoginAccount': 'Login Account',
    'LoginEmail': 'Email *',
    'LoginAccountAlreadyExists': 'Login Account already exists',
    'LoginAccountIsRequired': 'Login Account is required',
    'NameIsRequired': 'Name is required',
    'PhoneIsRequired': 'Phone is required',
    'BusinessNameIsRequired': 'Business Name is required',
    'ApplyNewPassword': 'Apply New Password',
    'NewPassword': 'New Password',
    'ConfirmPassword': 'Confirm Password *',
    'AccountIsRequired': 'Account is required',
    'ConfirmPasswordDoseNotMatchPassword': 'Confirm password dose not match password',
    'ConfirmPasswordIsRequired': 'Confirm Password is required',
    'WelcomeToJoin': 'Welcome to join',
    'YouNeedToEnteraValidEmail': 'You need to enter a valid email',
    'ResetPassword': 'Reset Password',
    'Email': 'Email',
    'SendEmail': 'Send Email',
    'EmailSent': 'Email Sent!',
    'WeJustSentAnEmailTo': 'We just sent an email to',
    'check': 'If you go check your email now, you should find a message from us with instructions on how to choose a new password for your account.',
    'notreceive': 'If you don\'t receive an email from us within a few minutes, please check your spam folder.',
    'BackTo': 'Back to',
    'EmailIsRequired': 'Email is required',
    'Projects': 'Projects',
    'Open': 'Open',
    'Closed': 'Closed',
    'NewProject': 'New Project',
    'Filters': 'Filters',
    'Loading': 'Loading',
    'Phone': 'Phone *',
    'CorpNameAlreadyExists': 'Business Name already exists'
  },
  'home': {
    'TIPS': 'TIPS',
    'Yes': 'Yes',
    'No': 'No',
    'Welcome': 'Welcome',
    'happening': 'Here\'s what\'s happening',
    'EditProject': 'Edit Project',
    'CloseProject': 'Close Project',
    'Progress': 'Progress',
    'CreateBy': 'Create by {0} {1}',
    'PLANS': 'PLANS',
    'AddPlan': 'Add Plan',
    'TASKS': 'TASKS',
    'Open': 'Open',
    'All': 'All',
    'REPORTS': 'REPORTS',
    'Activities': 'Last 20 Activities',
    'NoData': 'No Data',
    'AreYouSureYouWantToCloseThisProject': 'Are you sure you want to close this project?',
    'createdaTask': 'added a task ({0})',
    'assignTheTask': 'assigned the task ({0}) to {1}',
    'setTheProgress': 'changed the progress of task ({0}) to {1}%',
    'deletedaTask': 'deleted a task ({0})',
    'addRHReadingToTask': 'added RH reading to task({0})',
    'addCaClReadingToTask': 'added CaCl reading to task({0})',
    'removeaRH': 'deleted a RH reading from task ({0})',
    'removeaCaCl': 'deleted a CaCl reading from task ({0})',
    'createdaPlan': 'added a plan ({0})',
    'deletedaPlan': 'deleted a plan ({0})',
    'ReopenProject': 'Reopen Project',
    'AreYouSureYouWantToReopenThisProject': 'Are you sure you want to reopen this project?',
    'loggedInSystem': 'is logged in',
    'CreatedProject': 'add the project',
    'UpdatedProject': 'updated the project',
    'ClosedProject': 'closed the project',
    'ReopenedProject': 'reopened the project',
    'RenamePlan': 'renamed the plan ({0}) to ({1})',
    'AddProjectMember': 'invite ({0}) to the project ({1})',
    'DeletedProjectMember': 'deleted ({0}) from the project ({1})',
    'CreatedReport': 'add a report ({0})',
    'BatchCreateTask': 'add multiple tasks',
    'BatchChangeTask': 'updated multiple tasks',
    'BatchDeleteTask': 'deleted multiple tasks',
    'BatchCreatePlan': 'added multiple plans',
    'BatchUpdatedPlan': 'updated multiple plans',
    'BatchDeletePlan': 'deleted multiple plans',
    'BatchAddProjectMember': 'invite multiple users to the project ({0})',
    'CompletedTask': 'completed the task ({0})',
    'UpdatedTask': 'updated the task ({0})',
    'AddTaskChecklist': 'added checklist ({0}) to the task ({1})',
    'AddTaskChecklistItem': 'added checklist item ({0}) to the task ({1})',
    'DeleteTaskChecklistItem': 'deleted checklist item ({0}) from the task ({1})',
    'RenameTaskChecklistItem': 'renamed the checklist item ({0}) to ({1}) on the task ({2})',
    'CheckedTaskChecklistItem': 'check the checklist item ({0}) on the task ({1})',
    'CrossTaskChecklistItem': 'cross the checklist item ({0}) on the task ({1})',
    'AddTaskPhoto': 'added photo to the task ({0})',
    'DeleteTaskPhoto': 'deleted photo from the task ({0})',
    'AddTaskVideo': 'added a video to the task ({0})',
    'DeleteTaskVideo': 'deleted a video from the task ({0})',
    'AddProjectDocument': 'added the document ({0}) to the project ({1})',
    'DeleteProjectDocument': 'deleted the document ({0}) from the project ({1})',
    'AddTaskDocument': 'added the document ({0}) to the task ({1})',
    'DeleteTaskDocument': 'deleted the document ({0}) from the task ({1})',
    'AnnotateTaskPhoto': 'annotated photo to the task ({0})',
    'BatchAddTaskPhoto': 'added photos to the task ({0})',
    'BatchAddTaskVideo': 'added viedos to the task ({0})',
    'CreateTaskGroup': 'add a task group ({0})',
    'UpdateTaskGroup': 'updated the task group ({0})',
    'DeleteTaskGroup': 'deleted the task group ({0})',
    'DeleteTaskChecklist': 'deleted the checklist ({0}) from the task ({1})',
    'UncheckedTaskChecklistItem': 'uncheck the checklist item ({0}) on the task ({1})',
    'CheckedTaskChecklist': 'check the checklist ({0}) on the task ({1})',
    'UncheckedTaskChecklist': 'uncheck the checklist ({0}) on the task ({1})',
    'AddPlanTag': 'added tag {0} to plan {1}',
    'DeletePlanTag': 'deleted tag {0} from plan {1}',
    'RenameProjectDocument': 'renamed the document ({0}) to ({1})',
    'MoveProjectDocument': 'moved the document ({0}) to {1}',
    'AddFolder': 'added the folder ({0}) to the project',
    'RenameFolder': 'renamed the folder ({0}) to ({1})',
    'DeleteFolder': 'deleted the folder ({0}) from the project'
  },
  'diagrams': {
    'AddPlans': 'Add Plans',
    'EditPlan': 'Edit Plan',
    'Name': 'Name',
    'Rename': 'Rename',
    'Delete': 'Delete',
    'Today': 'Today',
    'Open': 'Open',
    'NoData': 'No Data',
    'Warning': 'Warning',
    'cannotBeDeleted': 'This plan has tasks attached and cannot be deleted!',
    'wantToDelete': 'Are you sure you want to delete {0}?',
    'TIPS': 'TIPS',
    'Yes': 'Yes',
    'No': 'No',
    'AddPlanFromPDF': 'Add Plan from PDF',
    'SearchPlanName': 'Search plan name',
    'SearchTag': 'Search tag',
    'GridView': 'Grid View',
    'ListView': 'List View',
    'Tasks': 'Tasks',
    'Tags': 'Tags',
    'CreatedOn': 'Created On'
  },
  'documents': {
    'Add': 'Add New',
    'Rename': 'Rename',
    'Delete': 'Delete',
    'Move': 'Move',
    'Folder': 'Folder',
    'Document': 'Document',
    'NewFolder': 'New Folder',
    'RenameFolder': 'Rename Folder',
    'Cancel': 'Cancel',
    'Save': 'Save',
    'UploadDocument': 'Upload Documents',
    'PleaseSelectDocument': 'Please select at least one document',
    'AreYouSureYouWantToDeleteDocuments': 'Are you sure you want to delete the selected document(s)?',
    'Name': 'Name',
    'SearchDocumentName': 'Search document name',
    'RenameFile': 'Rename File',
    'MoveFile': 'Move File',
    'UploadFiles': 'Upload files',
    'AddFolder': 'Create a new folder',
    'NoFolder': 'No folder',
    'FolderNameisrequired': 'Folder name is required'
  },
  'group': {
    'NewTaskGroup': 'New Task Group',
    'Name': 'Name',
    'Edit': 'Edit',
    'Tasks': 'Tasks',
    'Delete': 'Delete',
    'DueOn': 'Due on',
    'Open': 'Open ({0})',
    'Complete': 'Complete ({0})',
    'NoData': 'No Data',
    'AreYouSureYouWantToDeleteThisGroup': 'Are you sure you want to delete this group?',
    'Yes': 'Yes',
    'No': 'No',
    'Progress': 'Progress',
    'Concrete': 'Concrete',
    'TIPS': 'TIPS',
    'SearchTaskGroupName': 'Search task group name',
    'SaveAsTaskTemplate': 'Save as Task Template'
  },
  'members': {
    'AddMembers': 'Add Members',
    'Name': 'Name',
    'Email': 'Email',
    'Role': 'Role',
    'AreYouSureYouWantToDeleteThisMember': 'Are you sure you want to delete this member?',
    'Yes': 'Yes',
    'No': 'No',
    'TIPS': 'TIPS',
    'SearchMemberName': 'Search member name',
    'SearchMemberNameOrEmail': 'Search name or email'
  },
  'photo': {
    'Upload': 'Upload Photo / Video',
    'SelectAll': 'Select All',
    'Name': 'Name',
    'Task': 'Task',
    'LastUpdatedOn': 'Last Updated On',
    'Delete': 'Delete',
    'Download': 'Download',
    'NoData': 'No Data',
    'AreYouSureYouWantToDeleteThesePhotos': 'Are you sure you want to delete the selected photo(s)?',
    'TIPS': 'TIPS',
    'Yes': 'Yes',
    'No': 'No',
    'PleaseSelectPhoto': 'Please select at least one photo',
    'Plan': 'Plan',
    'RoomName': 'Room Name',
    'TaskName': 'Task Name',
    'NotFound': 'Photos not found.',
    'SearchPlan': 'Search plan',
    'SearchTaskName': 'Search task name',
    'SearchRoom': 'Search room',
    'CreatedOn': 'Created On'
  },
  'report': {
    'Name': 'Name',
    'Type': 'Type',
    'BatchDelete': 'Batch Delete',
    'ProjectName': 'Project Name',
    'CreatedTime': 'Created Time',
    'CreatedOn': 'Created On',
    'Actions': 'Actions',
    'Delete': 'Delete',
    'AreYouSureYouWantToDeleteThisReport': 'Are you sure you want to delete this report?',
    'TIPS': 'TIPS',
    'Yes': 'Yes',
    'No': 'No',
    'PleaseCheckOneTaskAtLast': 'Please check one task at last',
    'AreYouSureYouWantToDeleteTheseReport': 'Are you sure you want to delete the selected reports?',
    'Report': 'Report',
    'Task': 'Task',
    'ProductInstallation': 'Product Installation',
    'Moisture': 'Moisture',
    'Task Report': 'Task',
    'Product Installation': 'Product Installation',
    'Labor Report': 'Labor',
    'Moisture Report': 'Moisture',
    'Plan': 'Plan',
    'All': 'All',
    'SearchReportName': 'Search report name',
    'Download': 'Download',
    'SendEmail': 'Send Email'
  },
  'task': {
    'AddTask': 'Add Task',
    'CompletionRate': 'CompletionRate',
    'All': 'All',
    'Filters': 'Filters',
    'Name': 'Name',
    'Status': 'Status',
    'DueDate': 'Due Date',
    'Watching': 'Watching',
    'BatchDelete': 'Delete',
    'BatchEdit': 'Edit',
    'ExportToFile': 'Export (All)',
    'Plan': 'Plan',
    'Project': 'Project',
    'Group': 'Group',
    'SearchTaskName': 'Search task name',
    'NoTasksFound': 'No tasks of the selected type \'{0}\' were found.',
    'NoTasksFoundByCondition': 'No matching tasks found.',
    'PleaseCheckOneTaskAtLast': 'Please check one task at last',
    'AreYouSureYouWantToDeleteTheseTasks': 'Are you sure you want to delete the selected task(s)?',
    'TIPS': 'TIPS',
    'Yes': 'Yes',
    'No': 'No',
    'TaskGroup': 'Task Group',
    'LocationType': 'Location Type',
    'Floor': 'Floor',
    'Wall': 'Wall',
    'Elevation': 'Elevation',
    'Assignee': 'Assignee',
    'Report': 'Report',
    'Task': 'Task',
    'ProductInstallation': 'Product Installation',
    'Product Installation': 'Product Installation',
    'Moisture': 'Moisture',
    'NewReport': 'New Report',
    'Concrete': 'Concrete',
    'Labor': 'Labor',
    'Start': 'Start',
    'End': 'End',
    'CreatedOn': 'Created On',
    'UpdatedOn': 'Updated On'
  },
  'static': {
    'Labor': 'Labor',
    'Metric': 'Metric',
    'Imperial': 'Imperial',
    'Celsius': 'Celsius',
    'Fahrenheit': 'Fahrenheit',
    'Overview': 'Overview',
    'plan': 'Plans',
    'Tasks': 'Tasks',
    'TaskGroups': 'Task Groups',
    'Reports': 'Reports',
    'Liveanalytics': 'Analytics',
    'Photos': 'Photos',
    'Documents': 'Documents',
    'Members': 'Members',
    'MyCorp': 'My Corp',
    'UserManagement': 'User Management',
    'Subscription': 'Subscription',
    'Corporations': 'Corporations',
    'AllUsers': 'All Users',
    'LaborItems': 'Labor Items',
    'Settings': 'Settings',
    'SysSetting': 'Sys Setting',
    'days': ' days',
    'day': ' day',
    'YourTrialIsExpired': 'Your trial is expired!',
    'FreeLicenses': ' free licenses, ',
    'licensesPurchased': ' purchased licenses, ',
    'assigned': ' assigned',
    'YourSubscriptionIsExpired': 'Your subscription is expired!',
    'YourSubscriptionWillExpired': 'The subscription of {0} will expire in {1} days.',
    'justThen': 'just then',
    'secondsAgo': ' seconds ago',
    'aMinuteAgo': '1 minute ago',
    'minutesAgo': ' minutes ago',
    '1hourAgo': '1 hour ago',
    'hoursAgo': ' hours ago',
    'yesterday': 'yesterday',
    'daysAgo': ' days ago',
    'aWeekAgo': '1 week ago',
    'weeksAgo': ' weeks ago',
    'aMonthAgo': '1 month ago',
    'monthsAgo': ' months ago',
    'aYearAgo': '1 year ago',
    'yearsAgo': ' years ago',
    'LicenseDisabledTitle': 'Your account is disabled.',
    'LicenseExpiredTitle': 'Your subscription is expired.',
    'LicenseDisabledNote': 'The account {0} is disabled, please contact the administrator for more information.',
    'LicenseExpiredNote': 'The subscription of {0} is expired.',
    'Products': 'Products',
    'Notifications': 'Notifications',
    'ChecklistTemplates': 'Checklist Templates',
    'TaskTemplates': 'Task Templates',
    'SwitchCorp': 'Switch Corp',
    'Tags': 'Tags',
    'TaskGroupTemplates': 'Task Group Templates'
  },
  'router': {
    'Login': 'Login',
    'Register': 'Register',
    'Invite': 'Invite',
    'Forgot': 'Forgot',
    'ResetPassword': 'Reset Password',
    'LoginToLicense': 'Login to License',
    'Projects': 'Projects',
    'Home': 'Home',
    'Tasks': 'Tasks',
    'Plans': 'Plans',
    'TaskGroups': 'Task Groups',
    'Reports': 'Reports',
    'Liveanalytics': 'Analytics',
    'Photos': 'Photos',
    'Documents': 'Documents',
    'Members': 'Members',
    'Corp': 'Corp',
    'UserManagement': 'User Management',
    'Subscription': 'Subscription',
    'MyProfile': 'My Profile',
    'Corporations': 'Corporations',
    'AllUsers': 'All Users',
    'LaborItems': 'Labor Items',
    'CorpSetting': 'Corp Setting',
    'SysSetting': 'Sys Setting',
    'TaskList': 'Task List',
    'ByRoom': 'By Room',
    'room': 'room',
    'ByProduct': 'By Product',
    'Task': 'Task',
    'batchTask': 'batch Task',
    'role': 'Role Permissions',
    'LoginToUserManagement': 'Login to User Management',
    'NotificationSetting': 'Notifications',
    'ChecklistTemplates': 'Checklist Templates',
    'TaskTemplates': 'Task Templates',
    'Tags': 'Tags',
    'taskGroupTemplates': 'Task Group Templates'
  },
  'model': {
    'tasks are going to be created': 'tasks are going to be created.',
    'Probe': 'Probe',
    'showImage': 'Imported Plan',
    'Product': 'Product',
    'task': 'task',
    'ZoomIn': 'Zoom In',
    'ZoomOut': 'Zoom Out',
    'ZoomAll': 'Zoom to Fit',
    'Task': 'Task',
    'Tasks': 'Tasks',
    'ProductInstallation': 'Product Installation',
    'Product Installation': 'Product Installation',
    'Moisture': 'Moisture',
    'TaskTemplate': 'Task Template',
    'ClearFilter': 'Clear filter',
    'Type': 'Type',
    'Status': 'Status',
    'TaskGroup': 'Task Group',
    'LocationType': 'Location Type',
    'DueDate': 'Due Date',
    'From': 'From',
    'To': 'To',
    'Assignee': 'Assignee',
    'Watching': 'Watching',
    'AddTask': 'Add Task',
    'Rooms': 'Rooms',
    'Products': 'Products',
    'ThereIsNoProduct': 'There is no product',
    'PleaseCreate': 'Please create a {0} task first.',
    'Wall': 'Wall',
    'Label': 'Label',
    'Dimension': 'Dimension',
    'WallSection': 'Wall Section',
    'Annotation': 'Annotation',
    'RoomName': 'Room Name',
    'Name': 'Name',
    'StartDate': 'Start Date',
    'Location': 'Location',
    'Description': 'Description',
    'Cancel': 'Cancel',
    'Save': 'Save',
    'Next': 'Next',
    'SelectRoom': 'Select Rooms',
    'MaxRh': 'MaxRH',
    'HoleDepth': 'Hole Depth',
    'CreateTaskForEveryRoom': 'Create Task For Every Room',
    'EditTasks': 'Edit Tasks',
    '%Done': '%Done',
    'Delete': 'Delete',
    'AreYouSureYouWantToDeleteTheseTasks': 'Are you sure you want to delete the selected task(s)?',
    'TIPS': 'TIPS',
    'Yes': 'Yes',
    'No': 'No',
    'Search': 'Search',
    'CreateTask': 'Create Task',
    'ChangeAll': 'Change All',
    'Usage': 'Usage',
    'NetArea': 'Net Area',
    'Installed': 'Installed',
    'MarkAsDone': 'Mark as done',
    'Floor': 'Floor',
    'Base/LF': 'Base/LF',
    'Door': 'Door',
    'Successfully': 'Successfully',
    'AddReading': 'Add Reading',
    'Category': 'Category',
    'TotalQty': 'Total Qty',
    'QtyInstalled': 'Qty Installed',
    'RHInConcrete': 'RH In Concrete',
    'PHTesting': 'PH Testing',
    'StartingWeight': 'Starting Weight',
    'EndingWeight': 'Ending Weight',
    'NetWeightGain': 'Net Weight Gain',
    'ConCrete': 'ConCrete',
    'Ambient': 'Ambient',
    'SurfaceTemp': 'Surface Temp',
    'MoreReading': 'More Reading',
    'AddPhoto': 'Add Photo',
    'AreYouSureYouWantToDeleteThisPhoto': 'Are you sure you want to delete this photo?',
    'AreYouSureYouWantToDeleteThisTask': 'Are you sure you want to delete this task?',
    'BatchEdit': 'Batch Edit Tasks',
    'Labor': 'Labor',
    'Select': 'Select',
    'SelectAssignee': 'Who need to do this?',
    'SelectWatching': 'Who should know about this?',
    'DescribeTheTask': 'Describe the task',
    'SearchTaskName': 'Search task name',
    'TaskTotalQty': 'Total Qty',
    'JobsiteTotalQty': 'Total',
    'RetainageQty': 'Remaining',
    'TaskTotalQtyCannotGreaterThanJobsiteRetaingeQty': 'Total qty can not be greater than remaining qty.',
    'PleaseSelectOneProduct': 'Please select a product',
    'PleaseSelectOneTemplate': 'Please select a template',
    'DragToAdd': 'Drag and Click on the Plan',
    'Addmultipletasksfromrooms': 'Add Tasks from Rooms',
    'PleaseSelectRoom': 'Please select at least one room to add tasks',
    'Addmultipletasksfromproducts': 'Add Tasks from Products',
    'PleaseSelectProduct': 'Please select at least one product to add tasks'
  },
  'upload': {
    'SelectFile': 'Select File',
    'SelectPhoto/Video': 'Select Photo / Video',
    'SelectPhoto': 'Select Photo',
    'Upload': 'Upload',
    'Uploading': 'Uploading',
    'Waiting': 'The server is processing file, please wait a monent',
    'Cancel': 'Cancel',
    'SelectDoc': 'Select Document(s)',
    'Pleaseuploadamaximumofphotos/videos': 'Please upload a maximum of {0} photos/videos'
  },
  'taskDialog': {
    'Are you sure you want to delete this file?': 'Are you sure you want to delete this file?',
    'Task': 'Task',
    'AddMoisture': 'Add Moisture',
    'Saving': 'Saving...',
    'Location': 'Location',
    'Description': 'Description',
    'AddReading': 'Add Reading',
    'Name': 'Name',
    'Category': 'Category',
    'Status': 'Status',
    '%Done': '%Done',
    'TaskGroup': 'Task Group',
    'StartDate': 'Start Date',
    'DueDate': 'Due Date',
    'completed': 'Completion Date',
    'Assignee': 'Assignee',
    'Watching': 'Watching',
    'Product': 'Product',
    'NetArea': 'Net Area',
    'TotalQty': 'Total Qty',
    'QtyInstalled': 'Qty Installed',
    'Installed': 'Installed',
    'ChangeAll': 'Change All',
    'MaxRh': 'MaxRH',
    'RHInConcrete': 'RH In Concrete',
    'PHTesting': 'PH Testing',
    'HoleDepth': 'Hole Depth',
    'StartingWeight': 'Starting Weight',
    'EndingWeight': 'Ending Weight',
    'NetWeightGain': 'Net Weight Gain',
    'ConCrete': 'ConCrete',
    'Ambient': 'Ambient',
    'SurfaceTemp': 'Surface Temp',
    'MoreReading': 'More Reading',
    'AddPhoto': 'Add Photo',
    'Delete': 'Delete',
    'Save': 'Save',
    'MarkAsDone': 'Mark as done',
    'AreYouSureYouWantToDeleteThisChecklist': 'Are you sure you want to delete this checklist?',
    'AreYouSureYouWantToDeleteThisChecklistItem': 'Are you sure you want to delete this checklist item?',
    'AreYouSureYouWantToDeleteThisPhoto': 'Are you sure you want to delete this photo?',
    'TIPS': 'TIPS',
    'Yes': 'Yes',
    'No': 'No',
    'AreYouSureYouWantToDeleteThisTask': 'Are you sure you want to delete this task?',
    'Floor': 'Floor',
    'Wall': 'Wall',
    'Base/LF': 'Base/LF',
    'Door': 'Door',
    'ReadingList': 'Reading List',
    'AreYouSureYouWantToDeleteThisReading': 'Are you sure you want to delete this reading?',
    'EditTasks': 'Edit Tasks',
    'RH': 'RH',
    'Cacl': 'CaCl',
    'ConcreteTemp': 'Concrete Temp',
    'AmbientTemp': 'Ambient Temp',
    'ConcreteSurfaceTemp': 'Concrete Surface Temp',
    'AmbientRH': 'Ambient RH',
    'ReadingTime': 'Reading Time',
    'CaClStartingWeight': 'CaCl Starting Weight',
    'CaClEndingWeight': 'CaCl Ending Weight',
    'ExposureTime': 'Exposure Time',
    'RequireNumber': 'Require Number',
    'PHTestingIsError': 'PH Testing is error',
    'PHTestingIsEmpty': 'PH Testing is Empty',
    'CaClStartingWeightIsError': 'CaCl Starting Weight is error',
    'CaClStartingWeightIsEmpty': 'CaCl Starting Weight is Empty',
    'CaClEndingWeightIsError': 'CaCl Ending Weight is error',
    'CaClEndingWeightNeedBiggerThanCaClStartingWeight': 'CaCl Ending Weight need bigger than CaCl Starting Weight',
    'CaClEndingWeightIsEmpty': 'CaCl Ending Weight is Empty',
    'CaClStartingTimeIsEmpty': 'CaCl Starting Time is empty',
    'CaClEndingTimeNeedLaterThanCaClStartingTime': 'CaCl Ending Time need later than CaCl Starting Time ',
    'CaClEndingTimeIsEmpty': 'CaCl Ending Time is empty ',
    'RHReadingMustHaveArecordValue': 'RH Reading must have a record value',
    'EndTime': 'End Time',
    'StartTime': 'Start Time',
    'Cancel': 'Cancel',
    'Video': 'Video',
    'FromLocalDisk': 'From Local Disk',
    'FromProjectDocuments': 'From Project Documents',
    'AddFile': 'Add File',
    'Checklists': 'Checklists',
    'AddChecklist': 'Add Checklist',
    'RepeatAssignFileToTask': 'The file has been added to the current task, please do not add it again',
    'VaporEmission': 'MVER',
    'TaskTotalQty': 'Total Qty',
    'JobsiteTotalQty': 'Total',
    'RetainageQty': 'Remaining',
    'TaskTotalQtyCannotGreaterThanJobsiteRetaingeQty': 'Total qty can not be greater than project retained.',
    'PleaseSelectOneProduct': 'Please select a product'
  },
  'project': {
    'Upload': 'Upload',
    'Skip': 'Skip',
    'SelectPlan': 'Select Plan',
    'SelectLayers': 'Select Layers',
    'CreateProject': 'Create Project',
    'CreateWithCloud': 'MeasureSquare Cloud Project',
    'CreateWithPdf': 'PDF Blueprint',
    'CreateWithPdfs': 'PDF Blueprints',
    'CreateWithEmpty': 'No Project or Blueprint',
    'EnterInformation': 'Enter Info',
    'SearchforPlans': 'Search for Plans',
    'Name': 'Name',
    'Owner': 'Owner',
    'LastUpdated': 'Last Updated',
    'SelectAll': 'Select All',
    'Selected': 'Selected',
    'NoneSelected': 'None Selected',
    'ProjectManager': 'Project Manager',
    'InstallationManager': 'Installation Manager',
    'Subcontract': 'Subcontract',
    'Street': 'Street',
    'City': 'City',
    'State': 'State',
    'ZipCode': 'Zip Code',
    'Country': 'Country',
    'Cancel': 'Cancel',
    'Previous': 'Previous',
    'Next': 'Next',
    'Save': 'Save',
    'OK': 'OK',
    'PleaseEnterAname': 'Please enter a name',
    'EditProject': 'Edit Project',
    'Address': 'Address',
    'NoData': 'No Data',
    'Members': 'Members',
    'SelectMembers': 'Select Members'
  },
  'PhotoDialog': {
    'notsupported': 'H.265/HEVC files is not supported.'
  },
  'member': {
    'AddMembers': 'Add Members',
    'SearchforMembers': 'Search for Members',
    'Add': 'Add',
    'Cancel': 'Cancel',
    'NewCorpUser': 'New User'
  },
  'management': {
    'ApplyToCorps': 'Apply to Corps',
    'Corporations': 'Corporations',
    'CompanyName': 'Company Name',
    'Contact': 'Contact',
    'Id': 'Id',
    'CreatedTime': 'Created Time',
    'Apply': 'Apply',
    'Cancel': 'Cancel',
    'PleaseCheckOneCorporationAtLast': 'Please check one corporation at last',
    'ObjectTypeName': 'Object Type Name',
    'Items': 'Items',
    'Remark': 'Remark',
    'Add': 'Add',
    'Delete': 'Delete',
    'Save': 'Save',
    'ObjectTypeNameIsRequired': 'Object Type Name is required',
    'Edit': 'Edit',
    'New': 'New',
    'AreYouSureYouWantToDeleteThisCorp': 'Are you sure you want to delete this corporation?',
    'TIPS': 'TIPS',
    'Yes': 'Yes',
    'No': 'No',
    'ExportToCSV': 'Export to CSV',
    'ExportToExcel': 'Export to Excel'
  },
  'groupDialog': {
    'Name': 'Name',
    'StartDate': 'Start Date',
    'DueDate': 'Due Date',
    'Description': 'Description',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'AddTaskGroup': 'Add Task Group',
    'PleaseEnterAName': 'Please enter a name',
    'EditTaskGroup': 'Edit Task Group',
    'PhaseType': 'Type',
    'General': 'General',
    'BillingPeriod': 'Billing Period',
    'IsCurrent': 'Current Billing',
    'PleaseEnterAStartDate': 'Please enter a start date',
    'PleaseEnterADueDate': 'Please enter a due date',
    'StartDateCannotGreaterThenDueDate': 'Start date cannot greater then due date',
    'DueDateCannotGreaterToday': 'Due date cannot greater then today',
    'DescribeTheTaskGroup': 'Describe the task group',
    'SaveAsTaskTemplate': 'Save as Template',
    'TemplateName': 'Name',
    'PleaseEnterATemplateName': 'Please enter a name',
    'EditTaskGroupTemplate': 'Edit Task Group Template',
    'AddTaskGroupTemplate': 'Add Task Group Template'
  },
  'diagramDialog': {
    'SelectPlan': 'Select Plan',
    'SelectLayers': 'Select Layers',
    'SearchforPlans': 'Search for Plans',
    'Name': 'Name',
    'Owner': 'Owner',
    'LastUpdated': 'Last Updated',
    'SelectAll': 'Select All',
    'Cancel': 'Cancel',
    'Previous': 'Previous',
    'Save': 'Save',
    'AddingPlan': 'Adding Plan',
    'AddPlanFromPDF': 'Add Plan from PDF',
    'SelectPDF': 'Select PDF',
    'SelectPages': 'Select Pages',
    'PagesSelected': '{0} Pages Selected',
    'SearchPage': 'Search page to select',
    'PdfError': 'Invalid PDF',
    'SaveFailed': 'Save Failed',
    'PdfTooLarge': 'Pdf too large'
  },
  'corpDialog': {
    'Previous': 'Previous',
    'Next': 'Next',
    'Fupload': 'Confirm Password',
    'SubscribetoJobsiteTrakr': 'Upgrade to get unlimited projects & more',
    'month': 'month',
    'MONTHLY': 'MONTHLY',
    'year': 'year',
    'YEARLY': 'YEARLY',
    'license': 'license',
    'Starter': 'Starter',
    'Pro': 'Pro',
    'ProInfo1': 'All Features Of Starter Package, Plus',
    'ProInfo2': 'Unlimited Projects (5 Licenses, 200 GB Storage)',
    'ProInfo3': 'Collaboration Among Team, Subs And Clients',
    'ProInfo4': 'Moisture Reporting, Bluetooth Meter Integration',
    'ProInfo5': 'Additional License',
    'Enterprise': 'Enterprise',
    'EnterpriseInfo1': 'All Features Of Pro, Plus',
    'EnterpriseInfo2': 'Unlimited Project Storage',
    'EnterpriseInfo3': 'Comprehensive Management Dashboard',
    'EnterpriseInfo4': 'ERP/CRM Integration Support',
    'EnterpriseInfo5': 'API Connection And Support',
    'Licenses': 'Licenses',
    'More': 'More',
    'CustomAmount': 'Custom Amount',
    'Total': 'Total',
    'Cancel': 'Cancel',
    'Buy': 'Buy',
    'Pleasecreateyourcompanyinformationfirst': 'Please create your company information first.',
    'Company': 'Company',
    'BusinessName': 'Business Name',
    'Address': 'Address',
    'City': 'City',
    'State': 'State',
    'ZipCode': 'Zip Code',
    'Country': 'Country',
    'ContactInfo': 'Contact Info',
    'Contact': 'Contact',
    'Phone': 'Phone',
    'Fax': 'Fax',
    'Email': 'Email',
    'Save': 'Save',
    'BusinessNameisrequired': 'Business Name is required',
    'Logo': 'Logo',
    'Add': 'Add',
    'Up': 'Up',
    'Down': 'Down',
    'Delete': 'Delete',
    'Close': 'Close',
    'NoType': 'No Type.',
    'Typenotempty': 'Type not empty.',
    'TypeIsrequired': 'Type Is required.',
    'Edit': 'Edit ',
    'CorpSetting': 'Corp Setting',
    'M2Integration': 'M2 Integration',
    'Unit': 'Unit',
    'TemperatureUnit': 'Temperature Unit',
    'Name': 'Name',
    'InstallCarpet': 'Install Carpet',
    'InstallVinyl': 'Install Vinyl',
    'InstallWallPaper': 'Install WallPaper',
    'InstallTile': 'Install Tile',
    'InstallLaminate': 'Install Laminate',
    'InstallHardwood': 'Install Hardwood',
    'Price': 'Price',
    'AddLaborItem': 'Add Labor Item',
    'Nameisrequired': 'Name is required',
    'EditLaborItem': 'Edit Labor Item',
    'Hardwood': 'Hardwood',
    'Laminate': 'Laminate',
    'Tile': 'Tile',
    'WallPaper': 'WallPaper',
    'VinylRoll,VinylTile': 'VinylRoll,VinylTile',
    'CarpetRoll,CarpetTile': 'CarpetRoll,CarpetTile',
    'ChangePassword': 'Change Password',
    'Password': 'Password',
    'OldPassword': 'Old Password',
    'NewPassword': 'New Password',
    'ConfirmPassword': 'Confirm Password',
    'Passwordisrequired': 'Password is required',
    'OldPasswordisrequired': 'Old Password is required',
    'NewPasswordisrequired': 'New Password is required',
    'OldPasswordiserror': 'Old Password is error',
    'Confirmpassworddosenotmatchpassword': 'Confirm password dose not match password',
    'ConfirmPasswordisrequired': 'Confirm Password is required',
    'EditTrialExpiration': 'Edit Expiration',
    'TrialExpiration': 'Trial Expiration',
    'Type of service life': 'Type of service life',
    'duration': 'Duration',
    'number': 'Number',
    'AccountInfo': 'Account Info',
    'LoginAccount': 'Login Account',
    'UserInfo': 'User Info',
    'FullName': 'Name',
    'Role': 'Role',
    'CompanyName': 'Company Name',
    'CorpIsrequired': 'Please select one company',
    'EditUser': 'Edit User',
    'SubscriptionDetail': 'Subscription Detail',
    'CreatedOn': 'Created On',
    'Rate': 'Rate',
    'Quantity': 'Quantity',
    'Nextbillingdate': 'Next billing date',
    'Action': 'Action',
    'AddUser': 'Add User',
    'Selectonerole': 'Please select one role',
    'LoginAccountisrequired': 'Login Account is required',
    'Youneedtoenteravalidemail': 'You need to enter a valid email',
    'Avatar': 'Avatar',
    'EditLicense': 'Edit License',
    'TrialExpirationDate': 'Trial Expiration Date',
    'ChecklistTemplate': 'Checklist Template',
    'TemplateNameAlreadyExists': 'Name already exists',
    'TemplateItemNameAlreadyExists': 'Item already exists',
    'TemplateItemNameisrequired': 'Item is required',
    'Items': 'Items',
    'TaskTemplate': 'Task Template',
    'GroupName': 'Group Name',
    'TaskType': 'Task Type',
    'LoadCloudGroupMembers': 'Import M2 Cloud Group Members',
    'CannotDuplicateCreateCorp': 'The account information already exists, the duplicate company cannot be created.'
  },
  'reportDialog': {
    'Door': 'Door',
    'Base/LF': 'Base/LF',
    'Floor': 'Floor',
    'Wall': 'Wall',
    'Elevation': 'Elevation',
    'Products': 'Products',
    'Loading': 'Loading',
    'Type': 'Type',
    'SendMail': 'Send Mail',
    'To': 'To',
    'Subject': 'Subject',
    'Content': 'Content',
    'Report': 'Report',
    'Cancel': 'Cancel',
    'Send': 'Send',
    'Toisrequired': 'To is required',
    'Youneedtoenteravalidemail': 'You need to enter a valid email',
    'Subjectisrequired': 'Subject is required',
    'Name': 'Name',
    'Orientation': 'Orientation',
    'Landscape': 'Landscape',
    'Portrait': 'Portrait',
    'Rh': 'RH',
    'Cacl': 'CaCl',
    'Rh&Cacl': 'RH & CaCl',
    'ShowProduct': 'Show Product',
    'ShowTaskList': 'Show Task List',
    'ShowFloorPlan': 'Show Floor Plans',
    'ShowBluePrint': 'Show Blue Prints',
    'ShowPhotos': 'Show Photos',
    'Previous': 'Previous',
    'Next': 'Next',
    'Save': 'Save',
    'LoadingPlan': 'Loading Plan',
    'Nameisrequired': 'Name is required',
    'ProductInstallation': 'Product Installation',
    'Moisture': 'Moisture',
    'Task': 'Task',
    'Report-': ' Report - ',
    'Progress': 'Progress',
    'Concrete': 'Concrete',
    'Plan': 'Plan',
    'Location': 'Location',
    'Done': 'Done',
    'DueDate': 'Due Date',
    'StartDate': 'Start Date',
    'Assignee': 'Assignee',
    'Status': 'Status',
    'Notes': 'Notes',
    '%Done': '% Done',
    'Area': 'Area',
    'Group': 'Group',
    'CreateBy': 'Create By',
    'Job': 'Job',
    'MeasrueSquareCorp': 'Measrue Square Corp.',
    '221EWalnutSt': '221 E Walnut St, Suite 110, Pasadena, CA 91101 support@measuresquare.com',
    'Jobinfo': 'Job info',
    'Photos': 'Photos',
    'Date': 'Date',
    'AmbientRH%': 'Ambient RH, %',
    'AirTemp': 'Air Temp',
    'ConcreteSurfaceTemp': 'Concrete Surface Temp',
    'ConcreteTemp': 'Concrete Temp',
    'RHInConcrete%': 'RH In Concrete, %',
    'Reading': 'Reading',
    'MaxRH%': 'Max RH, %',
    'Hole Depth': 'Hole Depth',
    'MAX72Hrs': 'MAX 72 Hrs',
    'Min60Hrs': 'Min 60 Hrs',
    'TestTime': 'Test Time',
    'LBS': 'LBS. per 1000 sq/ft in a 24 hour period.',
    'Hrs': 'Hrs. Exposed = (Total)',
    'Gain': 'Gain in Weight(Grams) ✖ 117.707 = (Divided by Total Below) =',
    'MOISTUREFORMULA': 'MOISTURE FORMULA',
    'Thenmop': 'Then mop with Tap water. Repeat the procedure twice, then test again. Typically the higher the PH.',
    'Floors': 'Floors with a PH Level of 9 or higher must be corrected. It may be reduced by mopping the floor with a 10% Muriatic Acid wash. Allow the acid wash to dry. ',
    'ALLOWEDIS-8': 'ALLOWED IS - 8',
    'MAXIMLIMPH': 'MAXIMLIM P H',
    'lbs': 'lbs. or Less Over 1000 s/f in 24 hrs.',
    'MAXIMLIM': 'MAXIMLIM',
    'RECOMMENDED': 'RECOMMENDED',
    'MOISTURELEVELS': 'MOISTURE LEVELS',
    'BYTHE': 'BY THE C.R.I. &',
    'RFCIS': 'R.F.C.I.S',
    'Rubber': 'Rubber Tile / Solid Vinyl Tile / Wood / PVC Vinyl / Vinyl Strip / PVC Vinyl Backed Carpets / Epoxy',
    'Felt': 'Felt Backed Sheet Vinyl / Action Back Carpet / Linoleum (Varies by Manufacturer 3# to 5#).',
    'Vinyl': 'Vinyl Composition Tile. (Varies by Manufacture 5# to 7#).',
    'Depth': 'Depth from top of slab, in.',
    'RHinConcrete': 'RH in Concrete, %',
    'PHTesting': 'PH Testing',
    'AmbientRH': 'Ambient RH, %',
    'WeightGaining': 'Weight Gain in g.',
    'ExposureTime/Hrs': 'Exposure Time/Hrs',
    'Quatitive': 'Quatitive Anhydrous Calcium Chloride Test (moisture vapor reading from slab)',
    'Static': 'Static Moisture Condition (moisture contained in slab)',
    'AlkalinityCondition': 'Alkalinity Condition',
    'LocationRm': 'Location Rm',
    'MaxRH': 'Max RH, %',
    'RHInConcrete': 'RH In Concrete, %',
    'CaClStartingWeight': 'CaCl Starting Weight',
    'CaClEndingWeight': 'CaCl Ending Weight',
    'NetGramGainOf': 'Net Gram Gain Of',
    'StartTime': 'Start Time',
    'EndTime': 'End Time',
    'TotalTime': 'Total Time(H:M)',
    'TestHas': 'Test Has Passed / Failed',
    'HoleDepth': 'HoleDepth',
    'Temp&Humidity': 'Temp & Humidity Conditions Stable 48 hrs Prior & Durring Test.',
    'A/CSystem': 'A/C System On/Running For 48 Hrs Minimum.',
    'TIP': 'TIP: - IS UNMEASURED',
    'TotalCheck': 'Total Check > RH READINGS;',
    'Product': 'Product',
    'TotalQty': 'Total Qty',
    'Installed': 'Installed',
    'InstalledQty': 'Installed Qty',
    'Plans': 'Plans',
    'ProjectName': 'Project Name',
    'ProjectNumber': 'Project #',
    'ProjectManagerName': 'Project Manager Name',
    'InstallationManagerName': 'Installation Manager Name',
    'SubcontractorName': 'Subcontractor Name',
    'LaborDateRange': 'Labor Date Range',
    'SummaryInformation': 'Summary Information',
    'LaborDetails': 'Labor Details',
    'Quantity': 'Quantity',
    'LaborDescription': 'Labor Description',
    'Price': 'Price',
    'LineTotal': 'Line Total',
    'Room': 'Room',
    'CompletionDate': 'Completion Date',
    'ReportTotal': 'Report Total',
    'PunchRetainage': 'Punch Retainage',
    'SubcontractorPayroll': 'Subcontractor Payroll',
    'SubcontractorLaborReport': 'Subcontractor Labor Report',
    'UOM': 'UOM',
    'CarpetRoll': 'Carpet',
    'VinylRoll': 'Vinyl',
    'WallPaper': 'Wall Paper',
    'CarpetTile': 'Carpet Tile',
    'VinylTile': 'Vinyl Tile',
    'Tile': 'Tile',
    'Laminate': 'Laminate',
    'Hardwood': 'Hardwood',
    'Paint': 'Paint',
    'Grout': 'Grout',
    'AreaSurface': 'Surface',
    'AreaUnderlay': 'Underlayment',
    'Transition': 'Transition',
    'Bullnose': 'Bullnose',
    'Trim': 'Trim',
    'WallBase': 'Wall Base',
    'LinearRegular': 'Linear',
    'Count': 'Count',
    'AreaAdhesive': 'Adhesive',
    'Labor': 'Labor',
    'Freight': 'Freight',
    'Carpet': 'Carpet',
    'Install': 'Install',
    'SetEndTimeNote': 'End time needs to be greater than start time.',
    'None': 'None',
    'MissingLaborItem': 'There are some related items that are not set.',
    'UpdatedOn': 'Updated On',
    'ShowChecklist': 'Show Checklist',
    'Checklists': 'Checklists'
  },
  'api': {
    'WARNING': 'Warning',
    'ERROR': 'Error',
    'Successfully': 'Successfully',
    'This': 'This project can not check on web',
    'Job Trakr Starter': 'Job Trakr Starter',
    'Job Trakr Pro': 'Job Trakr Pro',
    'Job Trakr Enterprise': 'Job Trakr Enterprise',
    'Pause': 'Pause',
    'Paid': 'Paid',
    'Resume': 'Resume',
    'Updated': 'Updated',
    'Canceled': 'Canceled',
    'Failed': 'Failed',
    'Created': 'Created',
    'Recurring Billing': 'Recurring Billing',
    'Proration Charge': 'Proration Charge',
    'Sent': 'Sent',
    'Month': 'Month',
    'Turn off the auto-bill for the subscription': 'Turn off the auto-bill for the subscription',
    'Find a better software/services.': 'Find a better software/services.',
    'Overdue invoice. Subscription canceled automatically.': 'Overdue invoice. Subscription canceled automatically.',
    'Job Trakr Monthly Subscription': 'Job Trakr Monthly Subscription',
    'Job Trakr YEARLY Subscription': 'Job Trakr YEARLY Subscription',
    'Job Trakr Starter Monthly Subscription': 'Job Trakr Starter Monthly Subscription',
    'Job Trakr Starter Annual Subscription': 'Job Trakr Starter Annual Subscription',
    'Job Trakr Pro Monthly Subscription': 'Job Trakr Pro Monthly Subscription',
    'Job Trakr Pro Annual Subscription': 'Job Trakr Pro Annual Subscription',
    'Job Trakr Enterprise Monthly Subscription': 'Job Trakr Enterprise Monthly Subscription',
    'Job Trakr Enterprise Annual Subscription': 'Job Trakr Enterprise Annual Subscription',
    'Invalid members': 'Invalid members',
    'AccountExist': 'The login account already exists.',
    'Project Manager': 'Project Manager',
    'Administrator': 'Administrator',
    'Superintendent': 'Superintendent',
    'Field Rep': 'Field Rep',
    'Project Status': 'Project Status',
    'Task Status': 'Task Status',
    'Task Tags': 'Task Tags',
    'Task Work Type': 'Task Work Type',
    'Task Progress Options': 'Task Progress Options',
    'me': 'me',
    '400': 'Invalid account or password.',
    '403': 'Your MeasureSquare ID does not currently have a license assigned to access JobTrakr. Please contact your JobTrakr Admin to have one assigned or purchased.',
    '405': 'Your subscription is expired.',
    'TIPS': 'TIPS',
    'This project can not check on web': 'This project can not check on web',
    'The Name field is required': 'The Name field is required',
    'Year': 'Year',
    'Ultimate': 'Ultimate',
    'Due Date need to later than Start Date': 'Due Date need to later than Start Date',
    'Open': 'Open',
    'Pending': 'Pending',
    'Completed': 'Completed',
    'In Progress': 'In Progress',
    'Planned Work': 'Planned Work',
    'Issues': 'Issues',
    'Issue': 'Issue',
    'Fileslargerthan50Mcannotbeuploaded': 'Files larger than 50M cannot be uploaded.',
    'PhotoOrVideolargerthan50Mcannotbeuploaded': 'Photo or video larger than 50M cannot be uploaded.'
    // '4001': 'Cannot exceed the maximum number of users purchased.'
  },
  role: {
    'Create Project': 'Create Project',
    'Edit Project': 'Edit Project',
    'Close Project': 'Close Project',
    'Add Plan': 'Add Plan',
    'Delete Plan': 'Delete Plan',
    'Add Task': 'Add Task',
    'Edit Task': 'Edit Task',
    'Assign Task': 'Assign Task',
    'Delete Task': 'Delete Task',
    'Create Report': 'Create Report',
    'Edit Task Group': 'Edit Task Group',
    'Create Task Group': 'Create Task Group',
    'Delete Task Group': 'Delete Task Group',
    'My Corp': 'My Corp',
    'Edit Member': 'Edit Member',
    'just the task assignd': 'just the task assignd',
    'Permission': 'Permission',
    'Administrator': 'Administrator',
    'Project Manager': 'Project Manager',
    'Superintendent': 'Superintendent',
    'Field Rep': 'Field Rep'
  },
  'store': {
    'Loading': 'Loading'
  },
  'labor': {
    'Add Labor Group': 'Create Labor Report',
    'Name': 'Name',
    'Trades': 'Trades',
    'Retainage Rate:': 'Retainage Rate',
    'ret:': 'Retainage Rate:',
    'Labor': 'Labor',
    'Job Name:': 'Job Name',
    'Trades:': 'Trades',
    'Time Ranges:': 'Date Range',
    'All': 'All',
    'Edit': 'Edit',
    'Edit Labor Report': 'Edit Labor Report',
    'Delete Labor Report': 'Delete',
    'Description of Work': 'Description of Work',
    'Previous Billings': 'Previous Billings',
    'Current Billing': 'Current Billing',
    'Total Completed': 'Total Completed',
    'Uncompleted': 'Uncompleted',
    'Retainage': 'Retainage',
    'Action': 'Action',
    'Previous Billings:': 'Previous Billings:',
    'Current Billing:': 'Current Billing:',
    'Total Completed:': 'Total Completed:',
    'Sub Totals:': 'Sub Totals:',
    'Retainage:': 'Retainage:',
    'Uncompleted:': 'Uncompleted:',
    'Amount': 'Amount',
    'Unit Cost': 'Unit Cost',
    'Cancel': 'Cancel',
    'Save': 'Save',
    'Are you sure you want to delete this labor group?': 'Are you sure you want to delete this labor report?',
    'TIPS': 'TIPS',
    'Please Enter A Name': 'Please enter name',
    'Please Enter Retainage Rate from 0 to 100': 'Please enter retainage from 0 to 100',
    'Please Enter Retainage Rate': 'Please enter retainage',
    'Please Enter Time Ranges': 'Please enter time ranges',
    'StartDate': 'Start Date',
    'EndDate': 'End Date',
    'Export': 'Export',
    'Labor Billing Report-': 'Labor Billing Report - ',
    'BillingReportTitle': 'Labor Billing Report',
    'Billing Date Range:': 'Billing Date Range',
    'Export PDF Report': 'Export PDF Report',
    'SearchLaborName': 'Search labor name',
    'MenuProducts': 'Change Order'
  },
  'product': {
    'Products': 'Products',
    'TypeOfWork': 'Type of Work',
    'SKU': 'SKU/Name',
    'Caption': 'Caption',
    'ProductType': 'Type',
    'Trade': 'Trade',
    'Color': 'Color',
    'Unit': 'Unit',
    'TotalQuantity': 'Amount',
    'UnitCost': 'Unit Cost',
    'ContractAmount': 'Contract Amount',
    'BatchDelete': 'Batch Delete',
    'CreatedTime': 'Created On',
    'Actions': 'Actions',
    'New': 'New',
    'Edit': 'Edit',
    'Delete': 'Delete',
    'AreYouSureYouWantToDeleteThisProduct': 'Are you sure you want to delete this product?',
    'TIPS': 'TIPS',
    'Yes': 'Yes',
    'No': 'No',
    'PleaseCheckOneProductAtLast': 'Please check one product at last',
    'AreYouSureYouWantToDeleteTheseProducts': 'Are you sure you want to delete the selected products?',
    'All': 'All',
    'SearchSKU': 'Search SKU/Name',
    'None': 'None',
    'Centimeter': 'CM',
    'Meter': 'M',
    'LinearFeet': 'LF',
    'SquareMeter': 'M²',
    'SquareFeet': 'SF',
    'SquareYard': 'SY',
    'Liter': 'Liter',
    'CubicMeter': 'M³',
    'USGal': 'Gal',
    'Each': 'EA',
    'CarpetRoll': 'Carpet Roll',
    'VinylRoll': 'Vinyl Roll',
    'WallPaper': 'Wall Paper',
    'CarpetTile': 'Carpet Tile',
    'VinylTile': 'Vinyl Tile',
    'Tile': 'Tile',
    'Laminate': 'Laminate',
    'Hardwood': 'Hardwood',
    'Concrete': 'Concrete',
    'Paint': 'Paint',
    'Grout': 'Grout',
    'AreaSurface': 'Area Surface',
    'AreaUnderlay': 'Area Underlay',
    'Transition': 'Transition',
    'Trim': 'Trim',
    'WallBase': 'Wall Base',
    'LinearRegular': 'Linear Regular',
    'Count': 'Count',
    'TilePattern': 'Tile Pattern',
    'AreaAdhesive': 'AreaAdhesive',
    'Labor': 'Labor',
    'Freight': 'Freight',
    'Import': 'Import',
    'ExportTemplate': 'Template',
    'ProductTemplate': 'Product Template',
    'AreYouSureYouWantToReplaceDuplicateSKUs': 'Are you sure you want to replace duplicate SKUs',
    'CannotDeleteProductUsedInTask': 'This product has tasks attached and cannot be deleted!',
    'CannotDeleteSomeProductsUsedInTask': '{0} products are attached to the task and cannot be deleted!'
  },
  'productDialog': {
    'Cancel': 'Cancel',
    'Save': 'Save',
    'AddProduct': 'Add Product',
    'EditProduct': 'Edit Product',
    'SKU': 'SKU/Name',
    'Caption': 'Caption',
    'ProductType': 'Type',
    'Trade': 'Trade',
    'Color': 'Color',
    'Unit': 'Unit',
    'TotalQuantity': 'Amount',
    'UnitCost': 'Unit Cost',
    'Price': 'Price',
    'SKUisrequired': 'SKU/Name is required',
    'SKUAlreadyExists': 'SKU/Name already exists.',
    'Captionisrequired': 'Caption is required',
    'ProductTypeIsrequired': 'Type Is required.',
    'Unitisrequired': 'Unit is required',
    'QuantityMustGreaterThan0': 'Amount must greater than zero'
  },
  'markup': {
    'Start': 'Markup',
    'Done': 'Done'
  },
  'tagDialog': {
    'Name': 'Name',
    'Color': 'Color',
    'Cancel': 'Cancel',
    'Save': 'Save',
    'AddTag': 'Add Tag',
    'PleaseEnterAName': 'Please enter a name',
    'PleaseSelectColor': 'Please select a color',
    'EditTag': 'Edit Tag'
  },
  ...enlocale
}

export default en
